import Hero from './headfoot/Content'
import Footer from './headfoot/Footer'
import Header from './headfoot/Header'
import About from './About'
import Pillars from './Pillars'
import CTA from './CTA'
// import Feature from './Feature'

// export default function Home() {
//   return (
//     <>
//       <Hero />
//       {/* <Feature /> */}
//       <Footer />
//     </>
//   )
// }


import { useEffect, useRef } from "react"
// import { Link } from "react-router-dom"

export default function Home() {
  const navRef = useRef(null)

  useEffect(() => {
    // Sticky Nav
    const handleScroll = () => {
      if (!navRef.current) return
      navRef.current.classList.toggle("scrolled", window.scrollY > 60)
    }

    window.addEventListener("scroll", handleScroll)

    // Scroll Reveal
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("on")
          }
        })
      },
      { threshold: 0.12 }
    )

    document.querySelectorAll(".reveal").forEach((el) => {
      observer.observe(el)
    })

    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [])

  return (
    <div className="overflow-x-hidden">
      <Header navRef={navRef} />
      <Hero />
      <About />
      <Pillars />
      <CTA />
      <Footer />
    </div>
  )
}
